import { enumStatuses } from "../../consts/status";

const statusPalette = {
  OPEN: {
    chip: "bg-green-100 text-green-700",
    dot: "bg-green-600",
  },
  DRAFT: {
    chip: "bg-gray-100 text-gray-600",
    dot: "bg-gray-500",
  },
  CLOSED: {
    chip: "bg-blue-100 text-blue-700",
    dot: "bg-blue-600",
  },
  CANCELLED: {
    chip: "bg-red-100 text-red-700",
    dot: "bg-red-600",
  },
};

export default function PurchaseOrderStatusChip({ status, className = "" }) {
  const colors = statusPalette[status] || {
    chip: "bg-gray-100 text-gray-600",
    dot: "bg-gray-500",
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-sm font-medium leading-5 ${colors.chip} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${colors.dot}`} />
      {enumStatuses[status] || status}
    </span>
  );
}
